import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography"; 
import IconButton from "@material-ui/core/IconButton";
import MobileStepper from "@material-ui/core/MobileStepper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton"; 
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import DialogContentText from "@material-ui/core/DialogContentText";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Close from "@material-ui/icons/Close";

import AppContainerApplication from "../../common/AppContainerApplication"; 
import { ApplicationRecord, ApplicationRecordStatus, RCWDGrant } from "../../page/models";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AccTextField from "../../common/commonAccessability/accessabilityTextField.js";
import AccessabilitySelect from "../../common/commonAccessability/accessabilitySelect.js";
import AccFppCheckboxGroup from "../../common/commonAccessability/accessabilityCheckboxGroup.js";
import AccFppRadioGroup from "../../common/commonAccessability/accessabilityRadioGroup.js";
import AccHelpLabel from "../../common/commonAccessability/accessabilityHelpLabel.js";
import AccessabilityBaseMapControlApplication from "../../common/commonAccessability/accessabilityBaseMapControlApplication.js"; 
import AccessabilityWarningDialog from "../../common/commonAccessability/accessabilityWarningDialog.js";
 

const styles = (theme) => ({
    deleteWidth: {
        minWidth: 34,
        width: 34,
        marginRight: 8,
        marginTop: 2,
        marginBottom: 2,
    },
    centerAlign: {
        textAlign: "center",
    },
    centerAlign2: {
        textAlign: "center",
        display: "inline-block",
        width: "100%",
    },
    nowrap: {
        whiteSpace: "nowrap",
    },
    rightAlign: {
        textAlign: "right",
        marginRight: 15,
    },
    flex: {
        flex: 1,
    },
    printDivider: {
        height: 8,
        backgroundColor: "rgba(0, 0, 0, 0.42)",
        marginTop: 16,
        marginBottom: 8,
    },
    dialogMin: {
        minWidth: 330,
    },
    minWidth: {
        minWidth: 380,
    },
    root: {
        flexBasis: "100%",
        maxWidth: "100%",
    },
    btnroot: {
        color: "#9e9e9e",
    },
    buttonClass: {
        color: "white",
        backgroundColor: "#2845D6",
    },

    backbuttonClass: {
        color: "#2845D6",
        borderColor: "#2845D6"
    },
    stepperRoot: {
        "& .MuiStepIcon-root": {
            color: "#e0e0e0",
        },
        "& .MuiStepIcon-text": {
            fill: "#212121",
            fontWeight: 600,
        },
        "& .MuiStepIcon-root.MuiStepIcon-active": {
            color: "#2845D6",
        },
        "& .MuiStepIcon-root.MuiStepIcon-active .MuiStepIcon-text": {
            fill: "#ffffff",
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed": {
            color: "#2845D6",
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed .MuiStepIcon-text": {
            fill: "#ffffff",
        },
        "& .MuiStepLabel-label": {
            color: "#3d3d3d",
        },
        "& .MuiStepLabel-label.MuiStepLabel-active": {
            fontWeight: 600,
        },
    },
});

function MAKE_OPTIONS(table) {
    return table.map((row) => ({
        label: row,
        value: row,
        linkhref: row.linkhref,
        linkname: row,
        help: row.help
    }));
}



class RiceCreekGrant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            formKey: null,
            order: "desc",
            orderBy: null,
            loading: false,
            new_save: false,
            new_save2: false,
            mainFormKey: null,
            entryError: false,
            geometry: null,
            primaryContact: false,
            dialogLoading: false,
            alerts: "",
            outOfDistrict: false,
            address: null,
            city: null,
            zip: null,
            createPoint: false,
            projectType: [],
            reimbursementFormKey: null,
            expenseDialogOpen: false,
            expenseFormKey: null,
            saveDialogOpen: false,
            submittedSave: false,
            checkWhatFields: null,
            saveInfo: { owner_first_name: null, owner_last_name: null, owner_email: null },
            incompleteSave: false,
            maxFunds: 0,
            alertOpen: false,
            priorErrorsToClear: {},
            mainExplain: false,
            showProgressExtra: false,
            appData: null,
            historicAnnualReporting: [],
            historicAnnualAttachment: [],
            projTypeOptions: [],
            showOther: false,
            showMailing: false,
            agol_token: null

        };
    }
    componentDidMount() {
        const { match, ormRCWDGrantLoadDetailChild } = this.props;
        var component = this;
        // const {temp_attachments} = this.state
        // let newAttachments = temp_attachments
        fetch("/publicapp/agol/token")
            .then((res) => res.json())
            .then((results) => { 
                this.setState({ agol_token: results.token });
        });
        if (match.params && match.params.hash) {
            ormRCWDGrantLoadDetailChild(match.params.hash, function (hmm) {
                //set project options based on what was set before
                let projTypeOptions = []
                let showOther = false
                let proj_interested = hmm[0].proj_interested
                if (proj_interested.find(i => i === 'Other (specify below)')) {
                    showOther = true
                }
                let showMailing = hmm[0].proj_mailing_same == 'Yes' ? true : false

                component.setState({
                    appData: hmm[0], geometry: hmm[0].geometry,
                    mainExplain: hmm[0].main_explain, showOther, showMailing, mainFormKey: window.performance.now()
                })
                this.formApi.setValue('geometry', hmm[0].geometry)
            });
            // ormRiceCreekGrantAttachmentLoadDetailChild(match.params.hash, function (data) { 
            //     // data.forEach(att=>{ // we do this as we need the images that were saved previously 'id' key to not resave them again. 
            //     //         let temp = {}
            //     //         temp['id'] = 'blabla'
            //     //         temp['file'] = att.file
            //     //         temp['name'] = att.name
            //     //         temp['_type'] = att._type
            //     //         newAttachments.push(temp) 
            //     //     }) 
            //     component.setState({ temp_attachments: data });
            // })  
        }
        if (match.params && match.params.print) {
            component.setState({ activeStep: "PRINT" });
        }
    }


    submitApplication = (values, what) => {
        const {
            ormApplicationRecordCreate,
            ormApplicationRecordStatusCreate,
            ormRCWDGrantCreate,
            ormRCWDGrantUpdatePublic,
        } = this.props;
        const { checkWhatFields, geometry, alerts, appData } = this.state;

        const _this = this;

        // if(!alerts && what !== 'calcresave') this.setState({ loading: true }); //used for attachment alerts to not go into loading
        this.setState({ loading: true });

        let hasntSaved = false

        // Editing from a prior save but hasnt been submitted onto the internal ms4front side
        if (appData) {
            if (what === 'Save Not Completed') {//standard save or submitted  
                if (values.proj_interested && values.proj_interested.length === 0) delete values.proj_interested  //clear as wont take null
                ormApplicationRecordStatusCreate({
                    applicationrecord: appData.apprec.id,
                    status: 'Save Not Completed'
                }).then(statusrecord => {
                    ormRCWDGrantUpdatePublic({
                        applicationrecord: appData.apprec.id,
                        ...values
                    })
                    _this.setState({ loading: false, incompleteSave: true });
                    hasntSaved = true
                })

            } else {//submitted
                ormApplicationRecordStatusCreate({
                    applicationrecord: appData.apprec.id,
                    status: 'Applied'
                }).then(statusrecord => {
                    ormRCWDGrantUpdatePublic({//update only updates the store so use update public
                        applicationrecord: appData.apprec.id,
                        ...values
                    })
                    _this.setState({ loading: false, new_save: true });
                    hasntSaved = true
                })
            }
        } else if (what === 'Save Not Completed') {
            if (values.proj_interested && values.proj_interested.length === 0) delete values.proj_interested  //clear as wont take null
            ormApplicationRecordCreate({
                application: 22,
            }).then((ar) => {
                ormApplicationRecordStatusCreate({
                    applicationrecord: ar.id,
                    status: what
                }).then(bla => {
                    ormRCWDGrantCreate({
                        applicationrecord: ar.id,
                        geometry: geometry ? geometry : null,
                        ...values,
                    }).then((rpb) => {
                        if (rpb && rpb.error) {
                            this.setState({ entryError: true, loading: false });
                            fetch("/error/post", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    error: JSON.stringify(values),
                                    error_info: rpb.error.toString(),
                                }),
                            });
                        } else {
                            _this.setState({ loading: false, incompleteSave: true });
                        }
                    });
                })
            });
        } else {
            if (!alerts) {
                // NEW Applied  
                ormApplicationRecordCreate({
                    application: 22,
                }).then((ar) => {
                    ormApplicationRecordStatusCreate({
                        applicationrecord: ar.id,
                        status: "Applied"
                    }).then(bla => {
                        ormRCWDGrantCreate({
                            applicationrecord: ar.id,
                            geometry: geometry ? geometry : null,
                            ...values,
                        }).then((rpb) => {
                            if (rpb && rpb.error) {
                                this.setState({ entryError: true, loading: false });
                                fetch("/error/post", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                        error: JSON.stringify(values),
                                        error_info: rpb.error.toString(),
                                    }),
                                });
                            } else {
                                _this.setState({ loading: false, new_save: true });
                            }
                        });
                    })
                });
            }
        }
        this.setState({ checkWhatFields: null })
    };

    errorValidator = (values) => {
        const { checkWhatFields, priorErrorsToClear } = this.state;

        const isRequired = (val) => {
            return !val ? "Required" : null;
        };

        const validateEmail = (email) => {
            var re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !re.test(email) ? "Invalid Email Address" : null;
        };

        var valObj = {}
        var alerts = "";
        var ai = 2;

        if (checkWhatFields === 'Applied') {//check for Applied fields
            valObj = {
                owner_first_name: isRequired(values.owner_first_name),
                owner_last_name: isRequired(values.owner_last_name),
                owner_mailing_address: isRequired(values.owner_mailing_address),
                owner_phone: isRequired(values.owner_phone),
                owner_city: isRequired(values.owner_city),
                owner_state: isRequired(values.owner_state),
                owner_zip: isRequired(values.owner_zip),
                owner_email: validateEmail(values.owner_email),
                project_address: isRequired(values.project_address),
                project_city: isRequired(values.project_city),
                proj_interested: values.proj_interested && values.proj_interested.length > 0 ? null : 'Required',
                proj_desc: isRequired(values.proj_desc),
                proj_cost: isRequired(values.proj_cost),
                grant_rqst: isRequired(values.grant_rqst),
                printed_name: isRequired(values.printed_name),
                maintain: isRequired(values.maintain),
                participate: isRequired(values.participate),
                inspected: isRequired(values.inspected),
                geometry: isRequired(values.geometry),
            }
        }

        if (valObj["owner_first_name"] === "Required") {
            alerts += "Applicant First Name (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_last_name"] === "Required") {
            alerts += "Applicant Last Name (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_mailing_address"] === "Required") {
            alerts += "Applicant Mailing Address (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_city"] === "Required") {
            alerts += "Applicant City (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_state"] === "Required") {
            alerts += "Applicant State (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_zip"] === "Required") {
            alerts += "Applicant Zip (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_phone"] === "Required") {
            alerts += "Applicant Phone (Step 2)\n";
            ai = 1;
        }
        if (valObj["owner_email"] === "Invalid Email Address") {
            alerts += "Applicant Email (Step 2)\n";
            ai = 1;
        }
        if (valObj["geometry"] === "Required") {
            alerts += "Project Location needed on the map (Step 3)\n";
            ai = 2;
        }
        if (valObj["project_address"] === "Required") {
            alerts += "Project Address (Step 3)\n";
            ai = 2;
        }
        if (valObj["project_city"] === "Required") {
            alerts += "Project City (Step 3)\n";
            ai = 2;
        }
        //#4
        if (valObj["proj_interested"] === "Required") {
            alerts += "Type of project(Step 4)\n";
            ai = 3;
        }
        if (valObj["proj_desc"] === "Required") {
            alerts += "Description of project (Step 4)\n";
            ai = 3;
        }
        //#5
        if (valObj["proj_cost"] === "Required") {
            alerts += "Project Cost (Step 5)\n";
            ai = 4;
        }
        if (valObj["grant_rqst"] === "Required") {
            alerts += "Grant Request (Step 5)\n";
            ai = 4;
        }
        if (valObj["maintain"] === "Required") {
            alerts += "Maintain Project (Step 6)\n";
            ai = 5
        }
        if (valObj["participate"] === "Required") {
            alerts += "Participate in Outreach (Step 6)\n";
            ai = 5
        }
        if (valObj["inspected"] === "Required") {
            alerts += "Site Inspected (Step 6)\n";
            ai = 5
        }
        if (valObj["printed_name"] === "Required") {
            alerts += "Printed Name (Step 6)\n";
            ai = 5
        }


        if (alerts) {
            this.setState({ activeStep: ai, alerts: alerts, alertOpen: true, priorErrorsToClear: valObj });
        } else {
            // occurs if they try to submit first memoized form then save only as has those fields as problems so we need to clear the keys else reactform wont submit
            if (JSON.stringify(priorErrorsToClear) !== '{}') {
                Object.keys(priorErrorsToClear).forEach(key => { priorErrorsToClear[key] = null })
                this.setState({ alerts: alerts, priorErrorsToClear })
                valObj = { ...priorErrorsToClear }
            }
            this.setState({ alerts: alerts, priorErrorsToClear: valObj })
        }
        this.setState({ submittedSave: false, checkWhatFields: "" })
        return valObj;
    };

    handleRequestSort2 = (event, property) => {
        const orderBy = property;
        let order = "desc";

        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }

        order === "desc"
            ? this.state.temp_attachments.sort((a, b) => (b[orderBy].toUpperCase() < a[orderBy].toUpperCase() ? -1 : 1))
            : this.state.temp_attachments.sort((a, b) => (a[orderBy].toUpperCase() < b[orderBy].toUpperCase() ? -1 : 1));

        this.setState({ order, orderBy });
    };

    handleNext = (index) => {
        const { activeStep } = this.state;

        if (index || index === 0) {
            this.setState({ activeStep: index });
        } else if (activeStep < 5) this.setState({ activeStep: activeStep + 1 });
        else {
            this.formApi.submitForm();
        }
    };

    setDrawingFeature = (geom) => {
        if (geom) {
            this.formApi.setValue('geometry', geom)
            const { agol_token } = this.state   
            this.setState({ geometry: geom })
            if (geom) {//so in this case lets get the 4 service fields now and update on the UI
                //check if within boundary
                fetch(`
                    https://services.arcgis.com/m7XfTm3SBjnY2g9T/ArcGIS/rest/services/Basemap/FeatureServer/0/query?where=1=1&objectIds=&time=&geometry=${geom.coordinates[0]},${geom.coordinates[1]}
                    &geometryType=esriGeometryPoint&inSR=4326&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields
                    =&returnGeometry=true&returnCentroid=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision
                    =&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false
                    &returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false
                    &returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=`,
                    {
                        method: "GET"
                    })
                    .then(resp => resp.json())
                    .then(data => {
                        if (data.features.length === 0) {
                            this.setState({ outOfDistrict: true })
                        }
                    })

                //reverse geocode, get address, city zip
                fetch(`
                    https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?&f=pjson&featureTypes=&location=${geom.coordinates[0]},${geom.coordinates[1]}&token=${agol_token}`,
                    {
                        method: "GET"

                    })
                    .then(resp => resp.json())
                    .then(data => {
                        if (data.address) {
                            this.formApi.setValue("project_address", data.address.Address)
                            this.formApi.setValue("project_city", data.address.City) //if city isnt within list it wont show on dropdown
                            this.formApi.setValue("project_zip", data.address.Postal)
                        }
                    })
            }
        }
    }

    setPoint = () => {
        this.setState({ createPoint: false })
    }

    setDialogLoading = (e) => {
        this.setState({ dialogLoading: e })
    }
    defaultValues = () => {
        const { appData } = this.state
        let obj = {}
        if (!appData) {
            obj['proj_mailing_same'] = 'No'
            obj['geometry'] = null
        }
        if (appData) {
            obj = { ...appData }
        }
        return obj
    }


    render() {
        const { classes, mediaQuery } = this.props;
        const {
            activeStep,
            loading,
            new_save,
            mainFormKey,
            entryError,
            dialogLoading,
            outOfDistrict,
            hasAddress,
            saveDialogOpen,
            saveInfo,
            incompleteSave,
            alertOpen,
            alerts,
            appData,
            showOther,
            showMailing
        } = this.state


        var layers = [{
            attribution: "", city_id: 26, city_label: "Rice Creek Watershed District", id: 26, is_basemap: false,
            layer_type: "ArcGIS", layernumbers: "0", layerurl: "https://services.arcgis.com/m7XfTm3SBjnY2g9T/arcgis/rest/services/Basemap/FeatureServer/0",
            name: "Rice Creek Boundary", on_by_default: true, opacity: 1, order: 0, proxyurl: "", show_popup: false, subdomains: "",
            tileddynamic: "Feature Service", token: "", webmap_id: null, wmslayers: "", x: -93.0975, y: 45.1664,
            geocoder_left: [], geocoder_bottom: [], geocoder_right: [], geocoder_top: [], map_level: 10
        }]

        var is_read_only = false;


        if (appData && appData.apprec.status !== 'Save Not Completed') {
            is_read_only = true
        }


        if (incompleteSave) {
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "26" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>
                                This is a confirmation that the grant application has been saved, but not yet submitted to Rice Creek Watershed District. A copy of the grant application
                                has been emailed to the applicant's email address which will include a link to finish the application later.
                                Please check your spam and junk folders if you have not received it or contact the District.
                            </Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );
        }

        if (new_save) {
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "26" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>
                                This is a confirmation that the grant application has been submitted successfully. A copy of the grant application
                                has been emailed to the applicant's email address. Please check your spam and junk folders if you have
                                not received it or contact the district. The district will contact you as the application is being reviewed.
                            </Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );
        }
        if (entryError) {
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "26" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>
                                This grant application was 'not' successfully saved. Please contact the grant 'managing' staff to alert them of the
                                entry failure.
                            </Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );
        }

        let options2 = [
            "Native Plants",
            "Native Seed and Seed Mixes",
            "Shoreline Buffer Strip",
            "Turf Alternative",
            "Rain Garden",
            "Rain Barrel",
            "Targeted water education, information, or outreach activities",
            "Other (specify below)",
        ]

        var steps = ["Instructions",
            "Contact Information",
            "Project Location",
            "Project Plan",
            "Project Costs & Grant Request",
            "Review and Submit"
        ]

        let date = new Date()

        return (
            <AppContainerApplication
                city_id={"26"} //window.location.origin.includes("ms4prod") ? "45" : "2"}
                page_loading={loading}
                printing={activeStep === "PRINT"}>
                <main
                    id="main-content"
                    role="main"
                >
                    <Form
                        getApi={(el) => (this.formApi = el)}
                        defaultValues={appData}
                        key={mainFormKey}
                        dontValidateOnMount={true}
                        validateOnSubmit={true}
                        validateError={(values) => this.errorValidator(values)}
                        onSubmit={(values, e) => this.submitApplication(values, e)}>
                        {(formApi) => (
                            <form onSubmit={formApi.submitForm}>
                                <>
                                    {appData && appData.apprec && appData.apprec.status && (
                                        <Grid container spacing={1} style={{ backgroundColor: "#a3a3a3", marginTop: -15 }}>
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                <Typography className={classes.centerAlign} variant="h6">
                                                    Application Status: {appData && appData.apprec.status}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )}
                                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                                        <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                            <Typography
                                                className={classes.centerAlign}
                                                // variant="h6"
                                                variant="h1"
                                                style={{
                                                    fontSize: 23,
                                                    fontWeight: 400,
                                                    lineHeight: 1.6,
                                                }}
                                            >
                                                Grant Application Form {appData && appData.grant_number && "#" + appData.grant_number}
                                            </Typography>{" "}
                                            <Grid item xs={12} xl={10} className={classes.rightAlign} classes={{ root: classes.root }}></Grid>

                                            <Typography variant="caption" className={classes.centerAlign2}>
                                                Required fields are marked with an asterisk (*)
                                            </Typography>
                                        </Grid>
                                        {activeStep !== "PRINT" && (
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                {!mediaQuery ? (
                                                    <Typography
                                                        variant="subtitle1"
                                                        style={{ fontWeight: "bold", textAlign: "center" }}
                                                    >
                                                        <MobileStepper
                                                            variant="text"
                                                            steps={steps.length + " - " + steps[activeStep]}
                                                            position="static"
                                                            activeStep={activeStep}
                                                            style={{ backgroundColor: "rgb(240, 240, 240)" }}
                                                            nextButton={
                                                                <Button
                                                                    size="small"
                                                                    onClick={() => this.handleNext()}
                                                                    disabled={is_read_only && activeStep === 6}
                                                                    className={classes.buttonClass}
                                                                >
                                                                    {activeStep === 5 ? "Submit" : "Next"} <KeyboardArrowRight />
                                                                </Button>
                                                            }
                                                            backButton={
                                                                <Button
                                                                    size="small"
                                                                    onClick={() => this.setState({ activeStep: activeStep - 1 })}
                                                                    disabled={activeStep === 0}
                                                                >
                                                                    <KeyboardArrowLeft /> Back
                                                                </Button>
                                                            }
                                                        />
                                                    </Typography>
                                                ) : (
                                                    <nav
                                                        aria-label="Application steps"
                                                    >
                                                        <Stepper
                                                            style={{
                                                                padding: 8,
                                                            }}
                                                            alternativeLabel
                                                            nonLinear
                                                            activeStep={activeStep}
                                                        >
                                                            {steps.map((label, index) => (
                                                                <Step
                                                                    key={label}
                                                                >
                                                                    <StepButton
                                                                        onClick={() => this.handleNext(index)}
                                                                        className={classes.stepperRoot}
                                                                    >
                                                                        {label}
                                                                    </StepButton>
                                                                </Step>
                                                            ))}
                                                        </Stepper>
                                                    </nav>
                                                )}
                                            </Grid>

                                        )}
                                        {(activeStep === 0 && activeStep !== "PRINT") && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography
                                                    // variant="subtitle1"
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    <b>
                                                        {/* <u> */}
                                                        <i>
                                                            Welcome to the Rice Creek Watershed District Mini Grant Program Application
                                                        </i>
                                                        {/* </u> */}
                                                    </b>
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    The Mini-Grants Program provides an exciting opportunity for individuals and organizations to make a difference in their local communities.
                                                    It funds and supports projects that contribute to the improvement and protection of the watershed's water resources, while also fostering community engagement and environmental education.
                                                </Typography>
                                                <Typography
                                                    // variant="subtitle1"
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    <b>
                                                        {/* <u> */}
                                                        <i>
                                                            Eligibility
                                                        </i>
                                                        {/* </u> */}
                                                    </b>
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} All land or homeowners within the RCWD are eligible. This includes residents, churches, schools, communities, and businesses.
                                                    You are limited to one application per year. Single family landowners cannot receive funding in consecutive years.
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} Eligible projects include native plants, native seed and seed mixes, shoreline buffer strips, turf alternatives, rain gardens, rain barrels, targeted water education, information, or outreach activities.
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} Applications are reviewed on a first-come, first-serve basis based on eligibility criteria and will be awarded until program funds run out.
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`}Any questions regarding the application process, program eligibility, or application accessibility accommodations, please email Molly Nelson, {" "}
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href="mailto:mnelson@ricecreek.org">
                                                        mnelson@ricecreek.org
                                                    </a>{" "}
                                                </Typography>
                                                <br />
                                                <br />
                                            </Grid>
                                        )}
                                        {(activeStep === 1 || activeStep === "PRINT") && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography>Please add contacts associated with the inquiry.</Typography>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Applicant
                                                        </Typography>

                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_first_name"
                                                                    label="First Name *"
                                                                    fullWidth
                                                                    eventHandle={(e) => {
                                                                        let t = saveInfo
                                                                        t['owner_first_name'] = e
                                                                        this.setState({ saveInfo: t })
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_last_name"
                                                                    label="Last Name *"
                                                                    fullWidth
                                                                    eventHandle={(e) => {
                                                                        let t = saveInfo
                                                                        t['owner_last_name'] = e
                                                                        this.setState({ saveInfo: t })
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_organization"
                                                                    label="Organization"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_title"
                                                                    label="Title"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_mailing_address"
                                                                    label="Mailing Address *"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>

                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_city"
                                                                    label="City *"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="owner_state"
                                                                    label="State *"
                                                                    options={[{
                                                                        "label": "Minnesota",
                                                                        "value": "MN"
                                                                    }]}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_zip"
                                                                    label="Zip *"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_phone"
                                                                    label="Phone *"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="owner_email"
                                                                    label="Email *"
                                                                    fullWidth
                                                                    eventHandle={(e) => {
                                                                        let t = saveInfo
                                                                        t['owner_email'] = e
                                                                        this.setState({ saveInfo: t })
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === "PRINT" && (
                                            <>
                                                <div style={{ height: 50 }}></div>
                                                <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                    <Divider className={classes.printDivider} />
                                                </Grid>
                                            </>
                                        )}
                                        {(activeStep === 2 || activeStep === "PRINT") && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <br></br>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} xl={10} style={{ marginLeft: 15, marginRight: 15 }} classes={{ root: classes.root }}>

                                                        <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                            <Typography
                                                                // variant="subtitle1" 
                                                                gutterBottom
                                                                // style={{ marginBottom: -7, marginLeft: 14 }}
                                                                variant="h2"
                                                                style={{
                                                                    // font-size: 1rem;
                                                                    fontSize: 17,
                                                                    // font-weight: 400;
                                                                    fontWeight: 400,
                                                                    // line-height: 1.75;
                                                                    lineHeight: 1.75,
                                                                    marginBottom: -7,
                                                                    marginLeft: 14
                                                                }}
                                                            >
                                                                <b>Instructions:</b>
                                                            </Typography>

                                                            <Typography
                                                                // variant="subtitle1"
                                                                gutterBottom
                                                                // style={{ marginLeft: 16 }}
                                                                variant="h3"
                                                                style={{
                                                                    // font-size: 1rem;
                                                                    fontSize: 17,
                                                                    // font-weight: 400;
                                                                    fontWeight: 400,
                                                                    // line-height: 1.75;
                                                                    lineHeight: 1.75,
                                                                    marginLeft: 16
                                                                }}
                                                            >
                                                                Step 1: Use the + or - buttons to zoom the map to your grant location. Alternatively you can type an address or road intersection into the search box to zoom the map to the general location of your permit.
                                                            </Typography>

                                                            <Typography
                                                                // variant="subtitle1"
                                                                gutterBottom
                                                                // style={{ marginLeft: 16 }}
                                                                variant="h3"
                                                                style={{
                                                                    // font-size: 1rem;
                                                                    fontSize: 17,
                                                                    // font-weight: 400;
                                                                    fontWeight: 400,
                                                                    // line-height: 1.75;
                                                                    lineHeight: 1.75,
                                                                    marginLeft: 16
                                                                }}
                                                            >
                                                                Step 2: Click on the Mapping Tools button labeled "Add a New Project Location". This will change your mouse cursor to a blue dot. Click on the map to place your location of your permit. For linear projects place it on the approximate mid-point of the project. For other projects place the point on the best place that represents the location of your project.
                                                            </Typography>

                                                            <Typography
                                                                // variant="subtitle1"
                                                                gutterBottom
                                                                // style={{ marginLeft: 16 }}
                                                                variant="h3"
                                                                style={{
                                                                    // font-size: 1rem;
                                                                    fontSize: 17,
                                                                    // font-weight: 400;
                                                                    fontWeight: 400,
                                                                    // line-height: 1.75;
                                                                    lineHeight: 1.75,
                                                                    marginLeft: 16
                                                                }}
                                                            >
                                                                Step 3: After you place the point on the map, the Project Location fields will automatically populate. Verify those are the correct information.
                                                            </Typography>

                                                            <Typography
                                                                // variant="subtitle1"
                                                                gutterBottom
                                                                // style={{ marginLeft: 16 }}
                                                                variant="h3"
                                                                style={{
                                                                    // font-size: 1rem;
                                                                    fontSize: 17,
                                                                    // font-weight: 400;
                                                                    fontWeight: 400,
                                                                    // line-height: 1.75;
                                                                    lineHeight: 1.75,
                                                                    marginLeft: 16
                                                                }}
                                                            >
                                                                Step 4: If you need to modify the location of the point location on the map, Click Delete Project Location button and repeat Step 2. Otherwise click the Next button to proceed to the Project Type step.
                                                            </Typography>



                                                            <Typography
                                                                // variant="subtitle1" 
                                                                gutterBottom
                                                                // style={{ marginLeft: 16 }}
                                                                variant="h3"
                                                                style={{
                                                                    // font-size: 1rem;
                                                                    fontSize: 17,
                                                                    // font-weight: 400;
                                                                    fontWeight: 400,
                                                                    // line-height: 1.75;
                                                                    lineHeight: 1.75,
                                                                    marginLeft: 16
                                                                }}
                                                            >
                                                                <b> Please note: Projects not within District boundary outlined on the map will not be eligible for funding.</b>
                                                            </Typography>
                                                        </Grid>
                                                        <br></br>
                                                        <div>
                                                            If accessibility help is needed with mapping your location, please email Molly Nelson at {" "}
                                                            <a
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                href="mailto:mnelson@ricecreek.org">
                                                                mnelson@ricecreek.org
                                                            </a>{" "}
                                                        </div>
                                                        <AccessabilityBaseMapControlApplication
                                                            geometry={(appData && appData.geometry !== null) ? appData.geometry : (this.formApi && this.formApi.getValue('geometry')) ? this.formApi.getValue('geometry') : null}
                                                            disableSearch={(appData && appData.geometry !== null) ? appData.geometry : (this.formApi && this.formApi.getValue('geometry')) ? this.formApi.getValue('geometry') : false}
                                                            viewOnly
                                                            application={(appData && appData.geometry) ? appData : null}
                                                            setDialogLoading={this.setDialogLoading}
                                                            setDrawingFeature={this.setDrawingFeature}
                                                            layers={layers}
                                                            cityID={"26"}
                                                            geoType={'Point'} //call out which type we allow for in the map (i.e. point or multipoint)
                                                        />
                                                        {dialogLoading && (
                                                            <CircularProgress
                                                                size={72}
                                                                style={{ display: "table", marginLeft: "auto", marginRight: "auto", zIndex: 90000 }}
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ padding: 10 }}>

                                                        <Grid item xs={6}>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <AccTextField
                                                                label={
                                                                    <AccHelpLabel
                                                                        inputLabel="Project Address *"
                                                                        helpText="Address of site.
                                                                    "
                                                                    />
                                                                }
                                                                field="project_address"
                                                                disabled={is_read_only}
                                                                fullWidth

                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <AccTextField
                                                                disabled={is_read_only}
                                                                field="project_city"
                                                                label="Project City *"

                                                                fullWidth

                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <AccTextField
                                                                label="Project Zip"
                                                                field="project_zip"
                                                                disabled={is_read_only}
                                                                fullWidth

                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <AccFppRadioGroup
                                                                field="proj_mailing_same"
                                                                options={MAKE_OPTIONS(["Yes", "No"])}
                                                                alignment={true}
                                                                disabled={is_read_only}
                                                                eventHandle={(e) => {
                                                                    if (e === 'Yes') {
                                                                        this.setState({ showMailing: true })
                                                                    } else if (showMailing === true) {
                                                                        this.setState({ showMailing: false })
                                                                    }
                                                                }}

                                                                label="Is check mailing address different than project address? "
                                                            />
                                                        </Grid>
                                                        {showMailing && (
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="proj_mailing"
                                                                    label="Check Mailing Address "
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        )}

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {activeStep === "PRINT" && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Divider className={classes.printDivider} />
                                            </Grid>
                                        )}
                                        {(activeStep === 3 || activeStep === "PRINT") && (
                                            <>
                                                <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                                                        <Grid item xs={12}>
                                                            <AccFppCheckboxGroup
                                                                field="proj_interested"
                                                                label="What type of project(s) are you interested in (check all that apply)? *"
                                                                row={true}
                                                                width={205}
                                                                disabled={is_read_only}
                                                                // onlyAllowOne={true}
                                                                options={MAKE_OPTIONS(options2)}
                                                                eventHandle={(e) => {
                                                                    if (e.find((i) => i === 'Other (specify below)')) {
                                                                        this.setState({ showOther: true })
                                                                    } else if (showOther === true) {
                                                                        this.setState({ showOther: false })
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        {showOther && (
                                                            <Grid item xs={6}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="other"
                                                                    label="Other "
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        )}

                                                        <Grid item xs={12}>
                                                            <AccTextField
                                                                label="Please provide a summary of your project  *"
                                                                field="proj_desc"
                                                                disabled={is_read_only}
                                                                fullWidth
                                                                multiline
                                                                rows={6}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </>
                                        )}
                                        {(activeStep === 4 || activeStep === "PRINT") && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                fontSize: 16,
                                                                fontWeight: 300,
                                                                lineHeight: 1,
                                                            }}
                                                        >
                                                            <b>
                                                                <i>
                                                                    Project Costs & Grant Request
                                                                </i>
                                                            </b>
                                                        </Typography>
                                                    </AccordionSummary>

                                                    <AccordionDetails style={{ paddingBottom: 27, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} style={{ marginLeft: 15, marginTop: 5 }}>
                                                                <AccTextField
                                                                    useTextFormat={true}
                                                                    disabled={is_read_only}
                                                                    field="proj_cost"
                                                                    label="Estimated Project Costs *"
                                                                    fullWidth />
                                                            </Grid>
                                                            <Grid item xs={6} style={{ marginLeft: 15, marginTop: 5 }}>
                                                                <AccTextField
                                                                    useTextFormat={true}
                                                                    disabled={is_read_only}
                                                                    field="grant_rqst"
                                                                    label="Grant Request (up to $500.00) * "
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}

                                        {activeStep === "PRINT" && (
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                <Divider className={classes.printDivider} />
                                            </Grid>
                                        )}


                                        {(activeStep === 5 || activeStep === 'PRINT') && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography
                                                    // variant="subtitle1" 
                                                    gutterBottom
                                                    variant="h2"
                                                    style={{
                                                        fontSize: 16,
                                                        fontWeight: 300,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    <b>Please Read:</b>
                                                    {" "} Before submitting your application, ensure all the information provided in the application is correct. Do not start work on your project before receiving a signed grant award letter. Please note that applying does not guarantee mini-grant approval.
                                                    Grant reimbursement instructions will be provided in the award letter upon grant approval. All project work and reimbursement requests must be complete by December 1st, {date.getFullYear()}.
                                                    Additional Requirements: Projects must be maintained for a minimum of 5 years, and applicants must be willing to participate in RCWD's outreach and project sharing efforts. The RCWD does not complete the maintenance activities. A project may be visited and inspected by RCWD staff during the 5-year maintenance period. Please inform RCWD if you move within the 5 years of project implementation so we may provide the new owners with information on your installed project.

                                                </Typography>
                                                <br></br>
                                                <Typography
                                                    // variant="subtitle1" 
                                                    gutterBottom
                                                    variant="h2"
                                                    style={{
                                                        fontSize: 16,
                                                        fontWeight: 300,
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    <b>Additional Requirements:</b>
                                                    {" "} Projects must be maintained for a minimum of 5 years, and applicants must be willing to participate in RCWD's outreach and project sharing efforts. The RCWD does not complete the maintenance activities.
                                                    A project may be visited and inspected by RCWD staff during the 5-year maintenance period. Please inform RCWD if you move within the 5 years of project implementation so we may provide the new owners with information on your installed project.

                                                </Typography>
                                                <br></br>
                                                <Typography
                                                    // variant="subtitle1" 
                                                    gutterBottom
                                                >
                                                    <b>
                                                        {/* <u> */}
                                                        <i>
                                                            Agreements:
                                                        </i>
                                                        {/* </u> */}
                                                    </b>
                                                </Typography>
                                                {" "}
                                                <div style={{ paddingRight: 16 }}>
                                                    <AccFppRadioGroup
                                                        field="maintain"
                                                        options={MAKE_OPTIONS(["Yes", "No"])}
                                                        alignment={true}
                                                        disabled={is_read_only}

                                                        label="Maintain the project for at least 5 years after its implementation? *"
                                                    />
                                                </div>

                                                <div style={{ paddingRight: 16 }}>
                                                    <AccFppRadioGroup
                                                        field="participate"
                                                        options={MAKE_OPTIONS(["Yes", "No"])}
                                                        alignment={true}
                                                        disabled={is_read_only}

                                                        label="Participate in RCWD’s outreach and project sharing efforts?  *"
                                                    />
                                                </div>

                                                <div style={{ paddingRight: 16 }}>
                                                    <AccFppRadioGroup
                                                        field="inspected"
                                                        options={MAKE_OPTIONS(["Yes", "No"])}
                                                        alignment={true}
                                                        disabled={is_read_only}

                                                        label="Do you understand that your site may be visited and inspected by an RCWD employee during the 5 years after a grant is received? *"
                                                    />
                                                </div>

                                                <br></br>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="printed_name"
                                                        label="Printed Name *"
                                                        fullWidth
                                                    />
                                                </Grid>

                                            </Grid>
                                        )}
                                        {activeStep === "PRINT" && (
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                <Divider className={classes.printDivider} />
                                            </Grid>
                                        )}


                                        {activeStep !== "PRINT" && (
                                            <Grid item xs={12} xl={10} className={classes.rightAlign} classes={{ root: classes.root }}>
                                                {/* Applied CASE */}
                                                {(activeStep > 0 && (!appData || (appData && appData.apprec && appData.apprec.status !== 'Applied'))) && (
                                                    <Button
                                                        // disabled={activeStep <= 1 || is_read_only}
                                                        onClick={() => {
                                                            let fname = this.formApi.getValue('owner_first_name')
                                                            let lname = this.formApi.getValue('owner_last_name')
                                                            let em = this.formApi.getValue('owner_email')
                                                            let saveObj = { owner_first_name: fname, owner_last_name: lname, owner_email: em }
                                                            this.setState({ saveDialogOpen: true, saveInfo: saveObj })
                                                        }}
                                                        variant="contained"
                                                        // color="primary" 
                                                        className={classes.buttonClass}
                                                        style={{ marginRight: 16 }}
                                                    >
                                                        Save and Resume Later
                                                    </Button>
                                                )}
                                                {activeStep >= 0 && (
                                                    <>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => { this.setState({ activeStep: activeStep - 1 }); window.scrollTo(0, 0) }}
                                                            className={classes.backbuttonClass}
                                                        >
                                                            Back
                                                        </Button>

                                                        {(appData && appData.apprec.status !== 'Save Not Completed') && (
                                                            <Button
                                                                onClick={() => activeStep < 5 ? this.setState({ activeStep: activeStep + 1 }) : null}
                                                                disabled={activeStep === 5}
                                                                variant="contained"
                                                                // color="primary"
                                                                className={classes.buttonClass}
                                                                style={{ marginLeft: 16 }}>
                                                                Next
                                                            </Button>
                                                        )}
                                                        {((appData && appData.apprec.status === 'Save Not Completed') || !appData) && (
                                                            <Button
                                                                onClick={() => activeStep < 5 ? this.setState({ activeStep: activeStep + 1 }) : this.setState({ checkWhatFields: "Applied" }, () => {
                                                                    this.formApi.submitForm()
                                                                })}
                                                                // disabled={activeStep === 5 && appData}
                                                                variant="contained"
                                                                // color="primary"
                                                                className={classes.buttonClass}
                                                                style={{ marginLeft: 16 }}>
                                                                {activeStep < 5 ? "Next" : "Submit Inquiry"}
                                                            </Button>
                                                        )}
                                                    </>
                                                )}
                                            </Grid>
                                        )}
                                    </Grid>
                                    <Dialog open={saveDialogOpen} classes={{ paper: classes.minWidth }}>
                                        <Toolbar style={{ backgroundColor: "lightgray" }}>
                                            <Typography
                                                // variant="h6"
                                                className={classes.flex}
                                                variant="h2"
                                                style={{
                                                    fontSize: 24,
                                                    fontWeight: 400,
                                                    lineHeight: 1.5,

                                                }}
                                            >
                                                Save Progress and Resume Later?
                                            </Typography>
                                            <IconButton aria-label="Close Dialog" onClick={() => this.setState({ saveDialogOpen: false })}>
                                                <Close />
                                            </IconButton>
                                        </Toolbar>
                                        <Toolbar>
                                            <Typography
                                                // variant="h7"
                                                className={classes.flex}
                                                variant="h3"
                                                style={{
                                                    fontSize: 16,
                                                    fontWeight: 200,
                                                    lineHeight: 1,

                                                }}
                                            >
                                                Note: An email will be sent to the below email address where a link will be provided to resume this application. Keep in mind the application will not be processed until its fully filled out and submitted (i.e. step 6).
                                            </Typography>
                                        </Toolbar>
                                        <DialogContent className={classes.dialogMin}>
                                            <DialogContentText>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={6}>
                                                        <AccTextField
                                                            disabled={is_read_only}
                                                            field="owner_first_name"
                                                            label="First Name *"
                                                            fullWidth
                                                            eventHandle={(e) =>
                                                                this.formApi.setValue('owner_first_name', e)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <AccTextField
                                                            disabled={is_read_only}
                                                            field="owner_last_name"
                                                            label="Last Name *"
                                                            fullWidth
                                                            eventHandle={(e) =>
                                                                this.formApi.setValue('owner_last_name', e)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <AccTextField
                                                            disabled={is_read_only}
                                                            field="owner_email"
                                                            label="Email *"
                                                            fullWidth
                                                            eventHandle={(e) =>
                                                                this.formApi.setValue('owner_email', e)} />
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Button fullWidth onClick={() => this.setState({ saveDialogOpen: false })}>
                                                            Cancel
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Button
                                                            fullWidth
                                                            type="submit"
                                                            variant="contained"
                                                            // color="primary"
                                                            className={classes.buttonClass}
                                                            onClick={() => {
                                                                this.setState({ submittedSave: true, checkWhatFields: 'Save Not Completed' }, () => {
                                                                    this.formApi.submitForm('Save Not Completed')
                                                                })
                                                            }}>
                                                            Submit
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </DialogContentText>
                                        </DialogContent>
                                    </Dialog>
                                </>
                            </form>
                        )}
                    </Form>

                    {/* <WarningDialog
                        confirmAction={() => {
                            this.setState({ outOfDistrict: false });

                        }}
                        cancelAction={(e) => {
                            this.setState({ outOfDistrict: false });
                        }}
                        noDeleteButtons
                        confirmText="Ok"
                        open={outOfDistrict}
                        title="Confirm Address is within District Boundaries"
                        text={
                            "For sites located within close proximity to the approximate RPBCWD boundary identified on this map, the applicant must verify the legal property boundary with District staff."
                        }
                    /> */}

                    <AccessabilityWarningDialog
                        confirmAction={() => {
                            this.setState({ outOfDistrict: false });

                        }}
                        cancelAction={(e) => {
                            this.setState({ outOfDistrict: false });
                        }}
                        noDeleteButtons
                        confirmText="Ok"
                        open={outOfDistrict}
                        title="Confirm Address is within District Boundaries"
                        text={
                            "For sites located within close proximity to the approximate RPBCWD boundary identified on this map, the applicant must verify the legal property boundary with District staff."
                        }
                    />


                    <Dialog open={alertOpen} classes={{ paper: classes.minWidth }}>
                        <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                            <Typography variant="h6" className={classes.flex}>
                                Grant required fields
                            </Typography>
                            <IconButton aria-label="Close Dialog" onClick={() => this.setState({ alertOpen: false, alerts: "" })}>
                                <Close />
                            </IconButton>
                        </Toolbar>
                        <DialogContent className={classes.dialogMin}>
                            <DialogContentText>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography> <b><u>You must fill out the following required fields before submitting your application.</u></b></Typography>
                                        {alerts.split('\n').map((v, ix) => {
                                            let idx = ix + 1
                                            if (v) return <Typography>{idx}{".) "}{v}</Typography>
                                            else return null
                                        })}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button fullWidth onClick={(e) => {
                                            this.setState({ alertOpen: false })
                                        }}>
                                            Continue
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                </main>
            </AppContainerApplication>
        );
    }
}

RiceCreekGrant = connect(
    (state, ownProps) => ({
    }),
    {
        ...ApplicationRecord.actions,
        ...ApplicationRecordStatus.actions,
        ...RCWDGrant.actions,
    }
)(RiceCreekGrant);

const withMediaQuery = (...args) => Component => props => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
};

export default withStyles(styles)(withMediaQuery('(min-width:960px)')(withRouter(RiceCreekGrant)));
